import React from "react";
import styles from "./card.module.scss";
const LightweightCard = ({ className = "", children, id = "" }) => {
    return (React.createElement("div", { id: id, className: `${styles.vhvCard} ${className}` }, children));
};
export default LightweightCard;
